import { nameAndAddress } from '../people'
import type { AuthenticatedSession } from '../api'

/**
 * Who the document will be sent by. It is a line of text, not an input,
 * because the sender is whoever is signed in: typing an address here used to
 * be the only thing that said who sent a document, and anybody could type
 * anybody's.
 */
export function SentBy({
  session,
  organizationID,
}: {
  session: AuthenticatedSession
  organizationID: string
}) {
  const org = session.memberships.find((m) => m.organization_id === organizationID)
  return (
    <div id="sent-by" className="small muted" style={{ marginBottom: '.9rem' }}>
      <span className="faint">From </span>
      {nameAndAddress(session.identity.display_name, session.identity.email, '<>')}
      {org ? ` · ${org.organization_name}` : ''}
    </div>
  )
}

/**
 * Which organization the document belongs to. Almost everybody belongs to one,
 * and asking them to choose it would be asking a question with one answer, so
 * the picker only appears when there is a real choice to make.
 */
export function OrganizationPicker({
  session,
  value,
  onChange,
}: {
  session: AuthenticatedSession
  value: string
  onChange: (id: string) => void
}) {
  if (session.memberships.length < 2) return null
  return (
    <div>
      <label htmlFor="organization">Organization</label>
      <select id="organization" value={value} onChange={(e) => onChange(e.target.value)}>
        {session.memberships.map((m) => (
          <option key={m.organization_id} value={m.organization_id}>
            {m.organization_name}
          </option>
        ))}
      </select>
    </div>
  )
}
